import {
  type IMediaLibDialogItem,
  MediaLibPresetEnum,
  useMediaLibDialogStoreShallow,
} from "@editor/modules/media-lib";
import { useMediaLibDialogCtx } from "@editor/modules/media-lib/ctx";
import { Stock } from "../../stock-videos";
import type { IStockVideo } from "../../stock-videos/types";

export const MediaDialogStockVideos = () => {
  const { isMultiSelect, onSelect, preset } = useMediaLibDialogCtx();
  const { toggleSelectedItem, selectedItems } = useMediaLibDialogStoreShallow(
    (s) => ({
      selectedItems: s.selectedItems,
      toggleSelectedItem: s.toggleSelectedItem,
    }),
  );
  const handleClick = (video: IStockVideo) => {
    if (preset === MediaLibPresetEnum.OnlyImages) return;
    const url = video.url;
    const item: IMediaLibDialogItem = {
      id: video.url,
      url,
      type: "video",
      mediaFrom: "stock-video",
      shouldUpload: true,
    };

    if (!isMultiSelect) {
      onSelect(item);
      return;
    }

    toggleSelectedItem(item);
  };
  return (
    <Stock
      view="dialog"
      onSelect={handleClick}
      selectedItems={selectedItems}
      isMultiSelect={isMultiSelect}
    />
  );
};
